#import "../../OccupationFields.graphql"
mutation OccupationCreate($input: OccupationCreateInput!) {
  occupationCreate(input: $input) {
    userOccupationTitle {
     ...OccupationFields
 }
  }
}
